import * as views from './pages'

angular.module('app.catalogo').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.catalogo', {
            abstract: true
        })
        .state('app.catalogo.fgtssaqaniv', {
            url: '/processos/fgtssaqaniv',
            views: {
                'content@app': lazyLoadProvider.create(views.fgtsSaqAniv)
            },
            data: {
                title: 'Saque Aniversário',
                access: { requiredPermissions: ['security', 'backoffice', 'consultafgts'] },
                breadcrumbs: ['Processos', 'FGTS', 'Saque Aniversário']
            }
        })
});